import { CommonModule } from '@angular/common';
import { Component, OnDestroy, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import {
  AppNotificationItem,
  NotificationsService,
} from 'src/app/services/notifications.service';
import { navigateFromNotification } from 'src/app/shared/utils/notification-navigation.util';
import { Subscription } from 'rxjs';

@Component({
  selector: 'app-notifications-bell',
  standalone: true,
  imports: [CommonModule, MaterialModule, TablerIconsModule],
  templateUrl: './notifications-bell.component.html',
  styleUrls: ['./notifications-bell.component.scss'],
})
export class NotificationsBellComponent implements OnInit, OnDestroy {
  panelOpen = false;
  items: AppNotificationItem[] = [];
  unreadCount = 0;
  loading = false;
  loadingMore = false;
  hasMore = false;

  private feedSub: Subscription | null = null;

  constructor(
    private notifications: NotificationsService,
    private router: Router
  ) {}

  ngOnInit(): void {
    if (!this.isLoggedIn()) return;
    this.notifications.startPolling();
    this.feedSub = this.notifications.notifications$.subscribe((res) => {
      this.items = res.items || [];
      this.unreadCount = Number(res.unread_count || 0);
      this.hasMore = this.notifications.hasMore;
    });
  }

  ngOnDestroy(): void {
    this.feedSub?.unsubscribe();
    this.notifications.stopPolling();
  }

  togglePanel(): void {
    this.panelOpen = !this.panelOpen;
    if (this.panelOpen) {
      this.loading = true;
      this.notifications.refresh().subscribe({
        next: () => (this.loading = false),
        error: () => (this.loading = false),
      });
    }
  }

  closePanel(): void {
    this.panelOpen = false;
  }

  onItemClick(item: AppNotificationItem): void {
    const entityId = Number(item.entity_id);
    if (!Number.isFinite(entityId) || entityId <= 0 || !item.service_type) return;

    // Opening the notification does NOT dismiss it — it only goes away when
    // any recipient actually acts on the entity (comment / approve / reject)
    // or the user dismisses it explicitly via the per-item X.
    this.closePanel();
    void navigateFromNotification(this.router, item.service_type, entityId);
  }

  /** Per-item dismiss: removes only this notification, only for the current user. */
  dismissOne(event: Event, item: AppNotificationItem): void {
    event.stopPropagation();
    event.preventDefault();
    this.notifications.dismissOneForCurrentUser(item.id).subscribe();
  }

  loadMore(event: MouseEvent): void {
    event.stopPropagation();
    if (this.loadingMore || !this.hasMore) return;
    this.loadingMore = true;
    this.notifications.loadMore().subscribe({
      next: () => (this.loadingMore = false),
      error: () => (this.loadingMore = false),
    });
  }

  trackById(_index: number, item: AppNotificationItem): number {
    return item.id;
  }

  private isLoggedIn(): boolean {
    try {
      const raw = localStorage.getItem('user');
      if (!raw) return false;
      const user = JSON.parse(raw);
      return !!user?.id || !!user?.email;
    } catch {
      return false;
    }
  }
}
